"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    background: palette.elPrimary,
    pixelBackground: palette.tFilled,
    borderRadius: '3px',
    padding: palette.gutter + 'px'
  };
}